import { useQuery } from "react-query";
import { listBankDetailRequests } from "./api";
import Loader from "src/components/Dashboard/common/Loader";
import ProcessedRequests from "./ProcessedRequests";
import PendingRequests from "./PendingRequests";

const BankDetails = () => {
    const pendingQuery = useQuery(
        ["bank-detail-requests", "pending"],
        () => listBankDetailRequests("pending"),
    );
    const processedQuery = useQuery(
        ["bank-detail-requests", "processed"],
        () => listBankDetailRequests("processed"),
    );

    const refetchAll = () => {
        pendingQuery.refetch();
        processedQuery.refetch();
    };

    const isLoading = pendingQuery.isLoading || processedQuery.isLoading;
    const isFetching = pendingQuery.isFetching || processedQuery.isFetching;

    return (
        <div className="d-flex flex-column gap-3 w-100">
            <Loader show={isLoading || isFetching} />
            <PendingRequests
                data={pendingQuery.data?.items ?? []}
                totalCount={pendingQuery.data?.totalCount}
                refetch={refetchAll}
            />
            <ProcessedRequests
                data={processedQuery.data?.items ?? []}
                totalCount={processedQuery.data?.totalCount}
                refetch={refetchAll}
            />
        </div>
    );
};

export default BankDetails;
